import React from 'react';
import './styles.sass';
import SentimentSwatch from './SentimentSwatch';
import FeedbackWorkflow from './FeedbackWorkflow';

const Sentiment = ({ output, post }) => {
  return (
    <div className="Mentions-Output-Sentiment-Container">
      <SentimentSwatch sentimentScore={output.sentimentScore} />
      {output.sentimentScore !== null && (
        <>
          <span className="vertical-bar">|</span>
          <FeedbackWorkflow
            postType={post.postType}
            researchOutputId={output.id}
            postId={post.id}
            postUrl={post.url}
            sentimentScore={output.sentimentScore}
          />
        </>
      )}
    </div>
  );
};

export default Sentiment;
